import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { RootState, useSelector } from '../../../redux/store';
import { SEARCH_FIELD_NAMES } from '../../../constants';
import type { SelectOption } from '../../../types/common';

interface SelectMakerEnProps {
  value: string;
  onChangeMaker: (fieldName: string, value: string) => void;
}

const SelectMakerEn = ({ value, onChangeMaker }: SelectMakerEnProps): JSX.Element => {
  // console.log(name, value);
  const { steelMaker } = useSelector((state: RootState) => state.options);
  const steelMakers = steelMaker
    .filter((maker) => maker.nameEnglish !== undefined)
    .map((maker) => ({
      label: maker.nameEnglish.split('_').join(' '),
      value: maker.nameEnglish,
    }));
  const [selectedOption, setSelectedOption] = useState<SelectOption | null>(null);
  const [options, setOptions] = useState<SelectOption[]>(steelMakers);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (value !== '') {
      const newSelectedOption: SelectOption | undefined = options.find((option) => option.value === value);
      // console.log(newSelectedOption);
      if (newSelectedOption !== undefined) {
        setSelectedOption(newSelectedOption);
      }
    } else {
      setSelectedOption(null);
      onChangeMaker(SEARCH_FIELD_NAMES.MAKER_NAME_EN, '');
    }
  }, [value]);

  // EVENT HANDLER
  // ================================================================================

  const handleOptionChange = (option: SelectOption | null): void => {
    // console.log(option);
    setSelectedOption(option);
    const newValue: string = option.value;
    onChangeMaker(SEARCH_FIELD_NAMES.MAKER_NAME_EN, newValue);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <Select
        id={SEARCH_FIELD_NAMES.MAKER_NAME_EN}
        name={SEARCH_FIELD_NAMES.MAKER_NAME_EN}
        className="react-select-container"
        classNamePrefix="react-select"
        value={selectedOption}
        options={options}
        onChange={handleOptionChange}
        placeholder="Select..."
      />
    </>
  );
};

export default SelectMakerEn;
